var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "containerBlock",
      staticClass: "form-controls",
      class: { _mobile: _vm.isMobile },
      attrs: { id: "auth-form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.validate($event)
        }
      }
    },
    [
      _vm.isVisibleBonus || _vm.isVisibleEmailNotification
        ? _c(
            "div",
            { staticClass: "form-controls__success" },
            [
              _c("icon", {
                staticClass: "form-controls__success-icon",
                attrs: { name: "Success_52", width: "52", height: "52" }
              }),
              _vm._v(" "),
              _vm.isMobile
                ? _c("p", {
                    class: _vm.titleMobileClass,
                    domProps: { innerHTML: _vm._s(_vm.title) }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTitle
        ? _c("div", {
            class: _vm.titleClass,
            domProps: { innerHTML: _vm._s(_vm.title) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isRegistration
        ? _c("div", { staticClass: "form-controls__subtitle _mobile" }, [
            _vm._v(
              "\n    Присоединяйтесь к нашему сообществу любителей книг,\n    копите бонусные рубли и оплачивайте ими до 99% от стоимости заказа\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-controls__container" },
        [
          _vm.notify.caption
            ? _c(
                "form-item",
                { staticClass: "_mt" },
                [
                  _c(
                    "notify",
                    { ref: "notifyBlock", attrs: { type: _vm.notify.type } },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.notify.caption) + "\n        "
                      ),
                      _vm.isPhoneExist
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "form-controls__link _notify",
                                attrs: { type: "button", tabindex: "5" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.alertRecoverPassClickEvent(
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            Восстановить пароль\n          "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.state === "forgot"
            ? _c("div", { staticClass: "form-controls__item _desc _mt" }, [
                _vm._v("\n      " + _vm._s(_vm.forgotText) + "\n    ")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isRegistrationSuccess && !_vm.isConfirmRecovery
            ? _c(
                "form-item",
                _vm._b(
                  {
                    class: { _mt: _vm.state !== "forgot" },
                    attrs: { label: "Электронная почта", "is-gray-label": true }
                  },
                  "form-item",
                  _vm.fieldValidation("email"),
                  false
                ),
                [
                  _c("input-control", {
                    attrs: {
                      name: "email",
                      inputmode: "email",
                      autocomplete: "on",
                      tabindex: 1,
                      loading: _vm.isEmailChecking
                    },
                    on: { input: _vm.handlerInputEmail },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.state === "login"
            ? [
                _c(
                  "form-item",
                  _vm._b(
                    {
                      attrs: {
                        label: "Введите пароль",
                        "show-password": true,
                        "is-gray-label": true
                      }
                    },
                    "form-item",
                    _vm.fieldValidation("password"),
                    false
                  ),
                  [
                    _c("input-control", {
                      attrs: {
                        name: "password",
                        autocomplete: "on",
                        tabindex: 3
                      },
                      model: {
                        value: _vm.password,
                        callback: function($$v) {
                          _vm.password =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "password"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("form-item", { staticClass: "_desc _center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "form-controls__link",
                      attrs: { type: "button", tabindex: "5" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changeState("forgot")
                        }
                      }
                    },
                    [_vm._v("\n          Забыли пароль?\n        ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", {
                  ref: "recaptchaContainer",
                  class: { "b24-form-item": _vm.recaptchaWidget !== null }
                }),
                _vm._v(" "),
                _c(
                  "form-item",
                  { staticClass: "_desc _center" },
                  [
                    _c(
                      "button-control",
                      {
                        attrs: {
                          size: "large",
                          "native-type": "submit",
                          tabindex: 4,
                          loading: _vm.loading,
                          disabled: _vm.loading,
                          "is-block": true
                        }
                      },
                      [_vm._v("\n          Войти\n        ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("form-item", { staticClass: "_desc _center _no-mb" }, [
                  _vm._v("\n        Нет аккаунта?\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "form-controls__link",
                      attrs: { type: "button", tabindex: "1" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changeState("registration", true)
                        }
                      }
                    },
                    [_vm._v("\n          Зарегистрируйтесь\n        ")]
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.state === "registration"
            ? [
                _c(
                  "form-item",
                  _vm._b(
                    { attrs: { label: "ФИО", "is-gray-label": true } },
                    "form-item",
                    _vm.fieldValidation("name"),
                    false
                  ),
                  [
                    _c("input-control", {
                      attrs: {
                        placeholder: "Фамилия Имя Отчество",
                        name: "userName",
                        autocomplete: "off",
                        tabindex: 2,
                        "name-builder": true
                      },
                      model: {
                        value: _vm.name,
                        callback: function($$v) {
                          _vm.name = typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "name"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "form-item",
                  _vm._b(
                    {
                      attrs: { label: "Номер телефона", "is-gray-label": true }
                    },
                    "form-item",
                    _vm.fieldValidation("phone"),
                    false
                  ),
                  [
                    _c("input-phone-control", {
                      attrs: {
                        name: "userPhone",
                        autocomplete: "off",
                        tabindex: 3,
                        "is-masked": _vm.isRus
                      },
                      model: {
                        value: _vm.phone,
                        callback: function($$v) {
                          _vm.phone = typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "phone"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.needProof
                  ? _c("sms-confirm", {
                      ref: "smsConfirm",
                      staticClass: "_d form-controls__sms-confirm",
                      attrs: {
                        phone: _vm.phone,
                        "show-button-send": false,
                        "is-use-new-end-point": true,
                        "captcha-options": _vm.captchaOptions,
                        "captcha-options-v2": _vm.captchaOptionsV2
                      },
                      on: {
                        error: _vm.catchError,
                        incorrectPhone: _vm.incorrectPhone,
                        updateCaptchaV3: _vm.generateCaptcha,
                        verified: _vm.handlerVerified
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", {
                  ref: "recaptchaContainer",
                  staticClass: "form-controls__recaptcha",
                  class: { "b24-form-item": _vm.recaptchaWidget !== null }
                }),
                _vm._v(" "),
                _c(
                  "form-item",
                  [
                    _c(
                      "checkbox-control",
                      {
                        attrs: { "model-value": true },
                        model: {
                          value: _vm.isAgreeWithData,
                          callback: function($$v) {
                            _vm.isAgreeWithData = $$v
                          },
                          expression: "isAgreeWithData"
                        }
                      },
                      [
                        _c(
                          "checkbox-policy-text",
                          { staticClass: "_long-text" },
                          [
                            _vm._v(
                              "\n            Я согласен получать рекламные сообщения\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "form-item",
                  {
                    attrs: {
                      "text-error": !_vm.isAgreeWithRules
                        ? _vm.errorTextPolicy
                        : ""
                    }
                  },
                  [
                    _c(
                      "checkbox-control",
                      {
                        attrs: { "model-value": true },
                        model: {
                          value: _vm.isAgreeWithRules,
                          callback: function($$v) {
                            _vm.isAgreeWithRules = $$v
                          },
                          expression: "isAgreeWithRules"
                        }
                      },
                      [
                        _c(
                          "checkbox-policy-text",
                          { staticClass: "_long-text" },
                          [
                            _vm._v(
                              "\n            Я принимаю условия\n            "
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "form-controls__link",
                                attrs: { href: "/pravila/", target: "_blank" }
                              },
                              [
                                _vm._v(
                                  "\n              Пользовательского соглашения\n            "
                                )
                              ]
                            ),
                            _vm._v(
                              "\n            и даю своё согласие на обработку своих персональных данных в соответствии с\n            "
                            ),
                            _c(
                              "a",
                              {
                                staticClass: "form-controls__link",
                                attrs: {
                                  href: "/politika-obrabotki-pd/",
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              Политикой обработки ПД\n            "
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "form-item",
                  [
                    _c(
                      "button-control",
                      {
                        attrs: {
                          size: "large",
                          "native-type": "submit",
                          "is-block": true,
                          tabindex: 5,
                          loading: _vm.loading,
                          disabled: _vm.loading
                        }
                      },
                      [_vm._v("\n          Зарегистрироваться\n        ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("form-item", { staticClass: "_desc _center _no-mb" }, [
                  _vm._v("\n        Уже зарегистрированы?\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "form-controls__link",
                      attrs: { type: "button", tabindex: "1" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changeState("login")
                        }
                      }
                    },
                    [_vm._v("\n          Войдите на сайт\n        ")]
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isConfirmRecovery
            ? [
                _c("sms-confirm", {
                  ref: "smsConfirmRecovery",
                  staticClass: "_d",
                  attrs: {
                    phone: _vm.phone,
                    "show-button-send": false,
                    "is-use-new-end-point": true,
                    "captcha-options": _vm.captchaOptions,
                    "captcha-options-v2": _vm.captchaOptionsV2
                  },
                  on: {
                    error: _vm.catchError,
                    setState: _vm.changeState,
                    verified: _vm.handlerVerifiedRecovery,
                    updateCaptchaV3: _vm.generateCaptcha
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  ref: "recaptchaContainer",
                  staticClass: "form-controls__recaptcha",
                  class: { "b24-form-item": _vm.recaptchaWidget !== null }
                }),
                _vm._v(" "),
                _c("form-item", { staticClass: "_desc _center _no-mb" }, [
                  _vm._v("\n        Уже зарегистрированы?\n        "),
                  _c(
                    "button",
                    {
                      staticClass: "form-controls__link",
                      attrs: { type: "button", tabindex: "1" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changeState("login")
                        }
                      }
                    },
                    [_vm._v("\n          Войдите на сайт\n        ")]
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.state === "forgot"
            ? [
                _c("div", {
                  ref: "recaptchaContainer",
                  class: { "b24-form-item": _vm.recaptchaWidget !== null }
                }),
                _vm._v(" "),
                _c(
                  "form-item",
                  [
                    _c(
                      "button-control",
                      {
                        attrs: {
                          "native-type": "submit",
                          size: "large",
                          "is-block": true,
                          tabindex: 2,
                          loading: _vm.loading,
                          disabled: _vm.loading
                        }
                      },
                      [_vm._v("\n          Отправить\n        ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("form-item", { staticClass: "_desc _center _no-mb" }, [
                  _c(
                    "button",
                    {
                      staticClass: "form-controls__link",
                      attrs: { type: "button", tabindex: "3" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.changeState("login")
                        }
                      }
                    },
                    [_vm._v("\n          Войти на сайт\n        ")]
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isCart
            ? [
                _c("div", { staticClass: "form-controls__cart-guest" }, [
                  _c(
                    "a",
                    {
                      staticClass: "b24-btn _secondary _large _block",
                      attrs: { href: _vm.checkoutLink }
                    },
                    [
                      _c("span", { staticClass: "b24-btn__content" }, [
                        _vm._v(
                          "\n            Оформить заказ как гость\n          "
                        )
                      ])
                    ]
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isVisibleBonus
            ? [
                _c("div", { staticClass: "form-controls__column _no-mb" }, [
                  _c("p", {
                    staticClass: "form-controls__item _center _text _mbs",
                    class: { _nmt: _vm.isMobile },
                    domProps: { innerHTML: _vm._s(_vm.bonusText) }
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "b24-btn",
                      attrs: { href: "/novie-knigi/" }
                    },
                    [_vm._v("\n          Потратить бонусы\n        ")]
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isVisibleEmailNotification
            ? [_c("confirm-email-notification")]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }